import { ROUTES } from '@zing/shared/constants'
import { Page } from '../Page'
import ZingHotsiteRedirect from '../ZingHotsiteRedirect'
// tenants (VITE_TENANT, lowercase) whose Hotsite block redirects to /login by default.
const HOTSITE_BLOCKED_TENANTS: string[] = ['zing', 'zing-teia']

const HOTSITE_ALLOWED_PATHS_BY_TENANT: Record<string, string[]> = {
  zing: [ROUTES.HOTSITE.REGISTER.RESOLVER, ROUTES.HOTSITE.REGISTER.EVALUATOR],
  'zing-teia': [
    ROUTES.HOTSITE.REGISTER.CAIXA_EMPLOYEE,
    ROUTES.HOTSITE.REGISTER.SIMPLIFIED_RESOLVER,
    ROUTES.HOTSITE.REGISTER.PUBLIC_ADMINISTRATION,
    ROUTES.HOTSITE.REGISTER.RESOLVER,
    ROUTES.HOTSITE.MEETING_ROOM_RESERVATION,
  ],
}

// `path` is the route checked against the allowlist; `pageLookupPath` is the
// path used to look up the component in the pageRegistry (default: `path`
// itself). The two diverge in cases like RESOLVER_CONNECTION, which reuses
// RESOLVER's component but has its own route identity for the allowlist.
export const HotsitePage = (path: string, pageLookupPath: string = path): JSX.Element => {
  const activeTenant = ((import.meta.env.VITE_TENANT as string) ?? '').toLowerCase()
  const isBlockedTenant = HOTSITE_BLOCKED_TENANTS.includes(activeTenant)
  const isAllowedPath = (HOTSITE_ALLOWED_PATHS_BY_TENANT[activeTenant] ?? []).includes(path)
  if (isBlockedTenant && !isAllowedPath) {
    return <ZingHotsiteRedirect />
  }
  return Page(pageLookupPath)
}

export default HotsitePage
